/* tslint:disable */

declare var Object: any;
export interface StorageClaimInterface {
  "id"?: number;
}

export class StorageClaim implements StorageClaimInterface {
  "id": number;
  constructor(data?: StorageClaimInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageClaim`.
   */
  public static getModelName() {
    return "StorageClaim";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageClaim for dynamic purposes.
  **/
  public static factory(data: StorageClaimInterface): StorageClaim{
    return new StorageClaim(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageClaim',
      plural: 'StorageClaims',
      path: 'StorageClaims',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageClaim.ts